import { render } from "./BsLoginView.vue?vue&type=template&id=71318620&scoped=true"
import script from "./BsLoginView.vue?vue&type=script&lang=js"
export * from "./BsLoginView.vue?vue&type=script&lang=js"

import "./BsLoginView.vue?vue&type=style&index=0&id=71318620&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71318620"]])

export default __exports__